import { AlertControlType } from '@interface/common';

export const ACCENT: AlertControlType = 'accent';
export const DANGER: AlertControlType = 'danger';
export const DEFAULT: AlertControlType = 'default';
